import { Modal } from '@components/Component/Container/Modal/Modal.js';
import { TextBase } from '@components/Component/TextBase/TextBase.js';
/**
 *
 *
 */
export class DialogModal extends Modal {
    get caption() { return this._caption; }
    set caption(value) {
        this._propertySet('caption', value);
        this.renderCaption();
    }
    constructor(id, rootElement, dependencies = {}) {
        super(id, rootElement, dependencies);
        this.componentName = 'DialogModal';
        this._caption = '';
        this.includeSubmitButton = true;
        this.sheet = false;
    }
    captionTypesSet() {
        super.captionTypesSet();
        this.captionTypes.caption = 'caption';
    }
    initializeComponents() {
        const tipText = new TextBase('caption');
        tipText.caption = this._caption;
        this.componentsAdd([
            tipText
        ]);
    }
    //
    // protected initializeButtons() {
    // 	super.initializeButtons();
    //	
    // 	this.buttonAdd({
    // 		caption: this.CaptionManager.getCaption('system_ok_caption')
    // 		,id: 'submit'
    // 		,onClick: () => {
    // 			this.dialogSubmit();
    // 		}
    // 	});
    // }
    handleSubmit() {
        this.submit(true);
    }
    open(options) {
        const { caption, title, captionKey, captionKeyTokens } = options;
        if (caption) {
            this.caption = caption;
        }
        if (title) {
            this.title = title;
        }
        if (captionKey) {
            if (captionKeyTokens) {
                this.captionKeyTokens = captionKeyTokens;
            }
            this.captionKey = captionKey;
        }
        return super.open(options);
    }
    renderCaption() {
        const captionComponent = this.componentGet('caption');
        if (captionComponent) {
            captionComponent.caption = this._caption;
        }
    }
}
